package com.vizio.redwolf.auth.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Deprecated(message = "This class is deprecated and will be removed in a future version.")
@Serializable
@JsExport
data class PayAuthShippingAddress(
    val firstName: String,
    val lastName: String,
    val streetAddress: String? = null,
    val additionalAddress: String? = null,
    val city: String? = null,
    val state: String? = null,
    val postalCode: String? = null,
    val phone: String? = null,
)

@Deprecated(message = "This class is deprecated and will be removed in a future version.")
@Serializable
data class ResetAccountResponseBody(@SerialName("message") val message: String, @SerialName("description") val description: String)